import { z } from "zod";

import { DateTimeString, zDateTimeString } from "../../dateTypes.js";
import { OutputContentId, OutputId } from "../../idTypeBrands.js";
import { zOutputContentId, zOutputId } from "../../zod/ZodIdTypeBrands.js";
import { createAppSessionEventDefinition } from "../AppSessionEventDefinition.js";

export const CREATE_OUTPUT_CONTENT = createAppSessionEventDefinition({
  type: "CREATE_OUTPUT_CONTENT",
  payloadSchema: z.object({
    outputContentId: zOutputContentId,
    outputId: zOutputId,
    createdDate: zDateTimeString,
    mimeType: z.string(),
  }),
  logSafe: {
    outputContentId: true,
    outputId: true,
    createdDate: true,
    mimeType: true,
  },
  create: (payload: {
    outputContentId: OutputContentId;
    outputId: OutputId;
    createdDate: DateTimeString;
    mimeType: string;
  }) => payload,
  apply: ({
    indices,
    payload: { createdDate, mimeType, outputContentId, outputId },
    state,
  }) => {
    const warnings: string[] = [];

    if (state.outputs[outputId] == null) {
      warnings.push(`Output not found: ${outputId}`);
    }

    if (state.outputContents[outputContentId] != null) {
      warnings.push(
        `Output content previously existed, overwriting: ${outputContentId}`,
      );
    }

    state.outputContents[outputContentId] = {
      id: outputContentId,
      outputId,
      createdDate,
      mimeType,
    };

    (indices.outputIdToOutputContentIds[outputId] ??= []).push(outputContentId);

    return { warnings };
  },
});
